import "../../stylesheets/App.css";
import React from "react";

function UserAdminInformation(props) {
  const user = props.user || {};

  return (
    <div className="user-admin-information-container">
      <h2 className="subtitles">Datos: {user.name || ""}</h2>

      <input className="inp" type="text" disabled value={user.name || ""} />
      <input className="inp" type="number" disabled value={user.cedula ?? ""} />
      <input className="inp" type="text" disabled value={user.phone || ""} />
      <input className="inp" type="text" disabled value={user.email || ""} />
      <input className="inp" type="number" disabled value={user.age ?? ""} />
    </div>
  );
}

export default UserAdminInformation;
